import { memo } from 'react';
import Avatar from '@components/@core/Avatar';

const EmployeeQuotaList = ({ users }) => (
    <>
        <div className="d-flex">
            <div className="d-flex-4">
                <p className="dsl-m10 text-400 text-start">Employee</p>
            </div>
        </div>
        {users.map((item, index) => {
            const { user } = item;
            const { first_name, last_name, avatar } = user.profile;
            return (
                <div className="d-flex py-1" key={index}>
                    <div className="d-flex d-flex-4">
                        <Avatar className="d-flex-1" name={`${first_name} ${last_name}`} url={avatar} />
                        <div className="d-flex-3 dsl-b14 ms-2 text-start text-400 align-self-center">{`${first_name} ${last_name}`}</div>
                    </div>
                </div>
            );
        })}
    </>
);

export default memo(EmployeeQuotaList);
